import { observer } from 'mobx-react-lite'
import { Button, FullPageWrapper } from 'shared/ui'
import { ProgressSteps } from 'shared/ui/ProgressSteps'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'
import { RcsBadge } from 'pages/settings/pages/rcsV2/ui'
import { SenderProfileForm } from './SenderProfileForm/SenderProfileForm'
import { SenderPreview } from './SenderPreview/SenderPreview'

import styles from './styles.module.scss'

export const SenderDetails = observer(() => {
  const { navigationStore, senderStore, nextStepClick, saving } = useRcsWizardContext()

  const onNext = () => nextStepClick(RcsWizardSteps.senderDetails)

  return (
    <FullPageWrapper className={styles.page}>
      <div className={styles.wrap}>
        <div className={styles.main}>
          <div className={styles.header}>
            <RcsBadge />
            <ProgressSteps
              title='Sender details'
              step={navigationStore.getStepNumber(RcsWizardSteps.senderDetails)}
              total={navigationStore.allStepsLength}
            />
          </div>
          <div className={styles.formArea}>
            <SenderProfileForm />
          </div>
          <div className={styles.actions}>
            <Button
              text='Next'
              size='large'
              disabled={senderStore.isNextDisabled || saving}
              loading={saving}
              onClick={onNext}
              className={styles.nextButton}
            />
          </div>
        </div>
        <div className={styles.preview}>
          <SenderPreview />
        </div>
      </div>
    </FullPageWrapper>
  )
})
